import { render } from "./GoodsButton.vue?vue&type=template&id=3cb2eef4&scoped=true"
import script from "./GoodsButton.vue?vue&type=script&lang=js"
export * from "./GoodsButton.vue?vue&type=script&lang=js"

import "./GoodsButton.vue?vue&type=style&index=0&id=3cb2eef4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb2eef4"]])

export default __exports__